var React = require('react');

function IconPlay (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"}));
}

IconPlay.defaultProps = {"fill":"currentColor","viewBox":"0 0 16 16"};

module.exports = IconPlay;

IconPlay.default = IconPlay;
